module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_arrow_right03-bd943ff8e5008a4b69512479ddbd3fcd.svg";